export function CreateAirmeet(state = '', action) {
    switch (action.type) {
        case 'CreateAirmeet':
            return action.payload;
        case 'Error':
            return action.payload;
        default:
            return state;
    }
}

export function AirmeetStatus(state = '', action) {
    switch (action.type) {
        case 'AirmeetStatus':
            return action.payload;
        case 'Error':
            return action.payload;
        default:
            return state;
    }
}

export function IsScreenShare(state = {}, action) {
    switch (action.type) {
        case 'IS_SCREEN_SHARE':
            return action.payload ? { ...action.payload } : {};
        case 'Error':
            return action.payload ? { ...action.payload } : {};
        default:
            return state;
    }
}

export function isCustomMedia(state = {}, action) {
    switch (action.type) {
        case 'IS_CUSTOM_MEDIA':
            return action.payload ? { ...action.payload } : {};
        case 'Error':
            return action.payload ? { ...action.payload } : {};
        default:
            return state;
    }
}
